var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 6.968-6 6 6 6M21 12.968H4M3 12.968h1",
    stroke: "#2096F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M9 6.96777L3 12.9678L9 18.9678' stroke='%232096F3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M21 12.9678H4' stroke='%232096F3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M3 12.9678H4' stroke='%232096F3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";